import queryString from "query-string";
import { useQuery } from "react-query";
import {
    GetPenyewaKhususResponse,
} from "../../constants/types";
import axios from "../axios";

const handleRequest = async (
    id: number,
) => {
    const apiUrl = queryString.stringifyUrl({
        url: `/api/mruangans-khusus-history/${id}`,
    });
    const { data } = await axios.get<GetPenyewaKhususResponse>(apiUrl);
    return data.data;
};

export default function useDetailHistoryRoomExclusive(id: number, enabled: boolean) {
    return useQuery<GetPenyewaKhususResponse["data"]>(
        ["detailRoomExclusive", id],
        () => handleRequest(id),
        { enabled: !!id && enabled }
    );
}
